import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../layouts/se.layout.widget.abstract";
import { Layouts } from "../layouts/se.layouts";
import { SeOrganizationTileComponent } from "../organization/se.organization.tile.component";
import { SEEventDetailsStore } from "./se.event.details.store";

@Component({
    standalone: true,
    selector: "s25-ng-se-event-details-host-org-widget",
    template: `
        @if (eventStore.hostOrg()) {
            <se-organization-tile [org]="eventStore.hostOrg()" />
        }
    `,
    styles: `
        :host ::ng-deep .host-logo-placeholder svg {
            color: var(--color--link-text);
            opacity: 0.7;
        }

        se-organization-tile {
            display: block;
            width: min(30em, 100%);
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SeOrganizationTileComponent],
})
export class SeEventDetailsHostOrgWidgetComponent extends LayoutWidget<typeof SeEventDetailsHostOrgWidgetComponent> {
    static readonly META = {
        name: "Hosted By",
        info: "Shows the hosting organization for the event",
        settings: [],
        defaultSettings: {},
    } as const satisfies Layouts.WidgetStatic;

    public eventStore = inject(SEEventDetailsStore);
}
